<template>
  <span
    class="request-status-pill"
    :class="statusClass"
  >
    <i :class="statusIcon" aria-hidden="true"></i>
    <span class="request-status-pill__text">{{ statusLabel }}</span>
  </span>
</template>

<script>
import {
  getRequestStatus,
  isRequestStatusApproved,
  isRequestStatusNew,
  isRequestStatusRejected,
} from "@/project/Source/requestStatus.js";

export default {
  name: "RequestStatusBadge",
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    status() {
      return getRequestStatus(this.row);
    },
    isNew() {
      return isRequestStatusNew(this.status);
    },
    isApproved() {
      return isRequestStatusApproved(this.status);
    },
    isRejected() {
      return isRequestStatusRejected(this.status);
    },
    statusClass() {
      if (this.isApproved) return "request-status-pill--approved";
      if (this.isRejected) return "request-status-pill--rejected";
      return "request-status-pill--new";
    },
    statusIcon() {
      if (this.isApproved) return "bi bi-check-circle-fill";
      if (this.isRejected) return "bi bi-x-circle-fill";
      return "bi bi-hourglass-split";
    },
    statusLabel() {
      if (this.isApproved) return this.$t("commonApproved");
      if (this.isRejected) return this.$t("commonRejected");
      return this.$t("commonNew");
    },
  },
};
</script>

<style scoped>
.request-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem 0.65rem;
  border-radius: 9999px;
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  user-select: none;
  border: 1px solid transparent;
  transition: all 0.15s ease;
}

.request-status-pill i {
  font-size: 0.75rem;
}

.request-status-pill--approved {
  background: rgba(16, 185, 129, 0.12);
  color: #10b981;
  border-color: rgba(16, 185, 129, 0.25);
}

.request-status-pill--rejected {
  background: rgba(239, 68, 68, 0.12);
  color: #ef4444;
  border-color: rgba(239, 68, 68, 0.25);
}

.request-status-pill--new {
  background: rgba(245, 158, 11, 0.12);
  color: #f59e0b;
  border-color: rgba(245, 158, 11, 0.25);
}

html[data-theme="dark"] .request-status-pill--approved {
  background: rgba(16, 185, 129, 0.18);
  color: #34d399;
}

html[data-theme="dark"] .request-status-pill--rejected {
  background: rgba(239, 68, 68, 0.18);
  color: #f87171;
}

html[data-theme="dark"] .request-status-pill--new {
  background: rgba(245, 158, 11, 0.18);
  color: #fbbf24;
}
</style>
